import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import ModalHeader from "../../Shared/ModalHeader";
import ModalFooter from "../../Shared/ModalFooter";
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList";
import ServiceLineChild from "../../../Billing/Claims/ClaimDetails/Claiims/ServiceLineChild";
import isNull from '../../../../utils/NullChecking';
import { enumUtil } from "../../../../utils/Enum";
import Loader from "../../../shared/Loader/Loader"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import FormValidator from "../../../../utils/FormValidator"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import OpenQuickPopup from "../../../shared/OpenQuickPopup/OpenQuickPopup";
import ClaimsValidator from "../../../Billing/Claims/ClaimDetails/ClaimsValidator";
import { FindSecondChild } from "../../../../utils/FindMenuOption";
import AddNewDiagnosis from "../DiagnosisCode/AddNewDiagnosis";
import { useSelector } from "react-redux";
import SuperICDandCPTSearch from "../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch";
import AddNewProcedureCodes from "../ProcedureCode/AddNewProcedureCodes";
import AddNewModifier from "../Modifiers/AddNewModifier";

const ProcedureMacros = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'Procedure Macro')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Codes', 'Procedure Macro')?.IsDeleted
    let RecentICDs = useSelector(state => state.CodesDropDownReducer.RecentICD)
    let RecentCPTs = useSelector(state => state.CodesDropDownReducer.RecentCPT)
    let RecentModifiers = useSelector(state => state.CodesDropDownReducer.RecentModifier)
    let ProcedureMacros_model = {
        Name: "",
        Type: "",
        Description: "",
        Active: false,
        ICD1CodeID: "",
        ICD1Code: "",
        ICD2CodeID: "",
        ICD2Code: "",
        ICD3CodeID: "",
        ICD3Code: "",
        ICD4CodeID: "",
        ICD4Code: "",
        ICD5CodeID: "",
        ICD5Code: "",
        ICD6CodeID: "",
        ICD6Code: "",
        ICD7CodeID: "",
        ICD7Code: "",
        ICD8CodeID: "",
        ICD8Code: "",
        ICD9CodeID: "",
        ICD9Code: "",
        ICD10CodeID: "",
        ICD10Code: "",
        ICD11CodeID: "",
        ICD11Code: "",
        ICD12CodeID: "",
        ICD12Code: "",
        UpdatedDate: "",
        UpdatedBy: ""
    }
    let ProcedureMacrosServices_model = {
        ID: "0",
        ProcedureCodeID: "",
        ProcedureCode: "",
        Amount: "",
        Units: "1",
        Pointer1: "1",
        Pointer2: "",
        Pointer3: "",
        Pointer4: "",
        ModifierCodeID1: "",
        ModifierCode1: "",
        ModifierCodeID2: "",
        ModifierCode2: "",
        ModifierCodeID3: "",
        ModifierCode3: "",
        ModifierCodeID4: "",
        ModifierCode4: ""

    }
    let RepeatingValue = '';
    let myVal = {
        icd1Val: '',
        icd1ValField: '',
        icd2ValField: '',
        icd3ValField: '',
        icd4ValField: '',
        icd5ValField: '',
        icd6ValField: '',
        icd7ValField: '',
        icd8ValField: '',
        icd9ValField: '',
        icd10ValField: '',
        icd11ValField: '',
        icd12ValField: '',
        // validation: false
    }
    let validate_model = {
        valName: "",
        // valCDI: "",
    }
    const API_URL = enumUtil.controller.Claim
    const API_URL_General = enumUtil.controller.General
    const [mainProcedureMacros, setMianProcedureMacros] = useState(ProcedureMacros_model)
    const [ProcedureMacrosSaveupdatemodel, setProcedureMacroSaveupdatemodel] = useState({})
    const { isOpenProcedure, onClose, onDeleteProcedure, type } = { ...props }
    const [isOpen, setisOpen] = useState(false);
    const [isOpenChild, setisOpenChild] = useState(false)
    const [ICDvalidationModal, setICDvalidationModal] = useState(myVal)
    const [icdBody, setIcdBody] = useState({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": '' })
    const [is, setIs] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [serviceID, setServiceID] = useState("");
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [popup, setPopup] = useState(<></>);
    const [loadICD, setLoadICD] = useState(false);
    const [isOpenDiagnosis, setisOpenDiagnosis] = useState(false);
    const [DiagnosisCode, setDiagnosisCode] = useState();
    const [isClose, setIsClose] = useState();
    let ServiceLineValidation_Modal = {
        // DOSFromVal: '',
        // DOSToVal: '',
        CPTCodeVal: '',
        ModifierCode1Val: '',
        ModifierCode1UNI: '',
        ModifierCode2Val: '',
        ModifierCode2UNI: '',
        ModifierCode3Val: '',
        ModifierCode3UNI: '',
        ModifierCode4Val: '',
        ModifierCode4UNI: '',
        Pointer1Val: '',
        Pointer1UNI: '',
        Pointer2Val: '',
        Pointer2UNI: '',
        Pointer3Val: '',
        Pointer3UNI: '',
        Pointer4Val: '',
        Pointer4UNI: '',
        Pointer1ICD: '',
        Pointer2ICD: '',
        Pointer3ICD: '',
        Pointer4ICD: '',
        POSVal: '',
        UnitsVal: '',
    }
    const [serviceLineValidation, setServiceLineValidation] = useState([ServiceLineValidation_Modal])
    const [mainProcedureMacrosServices, setMianProcedureMacrosServices] = useState([ProcedureMacrosServices_model])
    const [ProcedureMacrosServicesSaveupdatemodel, setProcedureMacroServicesSaveupdatemodel] = useState([])
    const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": '' })
    const [modifierBody, setmodifierBody] = useState({ "TableName": enumUtil.enumAPITableName.Modifier, "SearchParam": '' })
    const [ProcedureCodes, setProcedureCodes] = useState()
    const [onProcedureSave, setOnProcedureSave] = useState(false)
    const handleChild = () => {
        setisOpenChild(!isOpenChild)
    }
    const [providerValidationModal, setProviderValidationModal] = useState(validate_model)
    const ProviderValidation = async () => {
        let ValidationModal = {
            valName: FormValidator(
                mainProcedureMacros.Name,
                enumUtil.enumValidationType.Required,
                'Name',
            ),
            // valCDI: FormValidator(
            //     mainProcedureMacros.ICD1Code,
            //     enumUtil.enumValidationType.Required,
            //     'Atleast 1 ICD'
            // )
        }
        await setProviderValidationModal(ValidationModal)
        validate_model = ValidationModal
    }
    useEffect(() => {
        if (props.ProcedureCode != null) {
            setProcedureCodes(props.ProcedureCode)
            setDel(true);
        }
        else {
            if (!onProcedureSave) {
                setProcedureCodes(0);
                setDel(false);
            }
            else {
                setDel(true);
            }

        }
    }, [])
    const handleProcedureMacrosChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainProcedureMacros };
        let saveModal = { ...ProcedureMacrosSaveupdatemodel }
        if (name === "Active") {
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }
        setMianProcedureMacros(modal)
        for (var property in ProcedureMacros_model) {
            if (name === property) {
                if (name === "Active") {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setProcedureMacroSaveupdatemodel(saveModal)
    }
    const handleSelectDiagnosisData = (selectedData, name, type) => {
        console.log(selectedData);
        let modal = { ...mainProcedureMacros };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'BillingProviderID') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.value;
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'ICD1Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
            } else if (name === 'ICD2Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code'])) {
                    myVal.icd2ValField = 'First Enter ICD1'
                }
            } else if (name === 'ICD3Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code']) || isNull(modal['ICD2Code'])) {
                    myVal.icd3ValField = 'First Enter ICD1 and ICD2'
                }
            } else if (name === 'ICD4Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code']) || isNull(modal['ICD2Code']) || isNull(modal['ICD3Code'])) {
                    myVal.icd4ValField = 'First Enter ICD1 ,ICD2 and ICD3'
                }
            } else if (name === 'ICD5Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code']) || isNull(modal['ICD2Code']) || isNull(modal['ICD3Code']) || isNull(modal['ICD4Code'])) {
                    myVal.icd5ValField = 'First Enter ICD1 ,ICD2, ICD3 and ICD4'
                }

            } else if (name === 'ICD6Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code']) || isNull(modal['ICD2Code']) || isNull(modal['ICD3Code']) || isNull(modal['ICD4Code'])
                    || isNull(modal['ICD5Code'])) {
                    myVal.icd6ValField = 'First Enter ICD1 ,ICD2, ICD3, ICD4 and ICD5'
                }
            }
            else if (name === 'ICD7Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code']) || isNull(modal['ICD2Code']) || isNull(modal['ICD3Code']) || isNull(modal['ICD4Code'])
                    || isNull(modal['ICD5Code']) || isNull(modal['ICD6Code'])) {
                    myVal.icd6ValField = 'First Enter ICD1 ,ICD2, ICD3, ICD4 , ICD5 and ICD6 '
                }
            }
            else if (name === 'ICD8Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code']) || isNull(modal['ICD2Code']) || isNull(modal['ICD3Code']) || isNull(modal['ICD4Code'])
                    || isNull(modal['ICD5Code']) || isNull(modal['ICD6Code']) || isNull(modal['ICD7Code'])) {
                    myVal.icd6ValField = 'First Enter ICD1 ,ICD2, ICD3, ICD4 , ICD5 , ICD6 and ICD7'
                }
            }
            else if (name === 'ICD9Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code']) || isNull(modal['ICD2Code']) || isNull(modal['ICD3Code']) || isNull(modal['ICD4Code'])
                    || isNull(modal['ICD5Code']) || isNull(modal['ICD6Code']) || isNull(modal['ICD7Code']) || isNull(modal['ICD8Code'])) {
                    myVal.icd6ValField = 'First Enter ICD1 ,ICD2, ICD3, ICD4 , ICD5 , ICD6 , ICD7 and ICD8'
                }
            }
            else if (name === 'ICD10Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code']) || isNull(modal['ICD2Code']) || isNull(modal['ICD3Code']) || isNull(modal['ICD4Code'])
                    || isNull(modal['ICD5Code']) || isNull(modal['ICD6Code']) || isNull(modal['ICD7Code']) || isNull(modal['ICD8Code']) || isNull(modal['ICD9Code'])) {
                    myVal.icd6ValField = 'First Enter ICD1 ,ICD2, ICD3, ICD4 , ICD5 , ICD6 , ICD7 , ICD08 and ICD09'
                }
            }
            else if (name === 'ICD11Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code']) || isNull(modal['ICD2Code']) || isNull(modal['ICD3Code']) || isNull(modal['ICD4Code'])
                    || isNull(modal['ICD5Code']) || isNull(modal['ICD6Code']) || isNull(modal['ICD7Code']) || isNull(modal['ICD8Code']) || isNull(modal['ICD9Code'])
                    || isNull(modal['ICD10Code'])) {
                    myVal.icd6ValField = 'First Enter ICD1 ,ICD2, ICD3, ICD4 , ICD5 , ICD6 , ICD7 , ICD08 , ICD09 and ICD10'
                }
            }
            else if (name === 'ICD12Code') {
                modal[name] = selectedData.display
                ProcedureMacrosSaveupdatemodel[name] = selectedData.display + "";
                ProcedureMacrosSaveupdatemodel[name + 'ID'] = selectedData.value + "";
                if (isNull(modal['ICD1Code']) || isNull(modal['ICD2Code']) || isNull(modal['ICD3Code']) || isNull(modal['ICD4Code'])
                    || isNull(modal['ICD5Code']) || isNull(modal['ICD6Code']) || isNull(modal['ICD7Code']) || isNull(modal['ICD8Code']) || isNull(modal['ICD9Code'])
                    || isNull(modal['ICD10Code']) || isNull(modal['ICD11Code'])) {
                    myVal.icd6ValField = 'First Enter ICD1 ,ICD2, ICD3, ICD4 , ICD5 , ICD6 , ICD7 , ICD08 , ICD09 , ICD10 and ICD11'
                }
            }
        } else {
            modal[name] = ''
            ProcedureMacrosSaveupdatemodel[name] = ''
        }
        setMianProcedureMacros(modal)
        setICDvalidationModal(myVal)
        return selectedData
    }
    const handleDiagnosisChange = (e) => {
        // setClaimInfoVal(ValidationModal)
        setIs(false)
        let { name, value } = e.target
        let modal = { ...mainProcedureMacros }
        modal[name] = value
        setMianProcedureMacros(modal)
        setIcdBody({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": value })
        setMianProcedureMacros(modal)
    }
    const handleSaveProvider = async () => {

        let ProcedureCodeValidation = false
        let ICDValidator = false;
        mainProcedureMacrosServices.map((item) => {
            if (isNull(item.ProcedureCode)) {
                ProcedureCodeValidation = true
            }
        })
        const icdCodes = [
            mainProcedureMacros.ICD1Code,
            mainProcedureMacros.ICD2Code,
            mainProcedureMacros.ICD3Code,
            mainProcedureMacros.ICD4Code,
            mainProcedureMacros.ICD5Code,
            mainProcedureMacros.ICD6Code,
            mainProcedureMacros.ICD7Code,
            mainProcedureMacros.ICD8Code,
            mainProcedureMacros.ICD9Code,
            mainProcedureMacros.ICD10Code,
            mainProcedureMacros.ICD11Code,
            mainProcedureMacros.ICD12Code,
        ].filter((code) => !isNull(code));
        const hasDuplicates = icdCodes.some(
            (value, index) => icdCodes.indexOf(value) !== index
        );
        if (hasDuplicates) {
            RepeatingValue = 'ICD values must be Unique'
        } else {
            RepeatingValue = '';
        }
        let val = Object.values(ICDvalidationModal)
        val.map((item) => {
            if (!isNull(item)) {
                ICDValidator = true
            }
        })
        // let serviceLineVal = serviceLineValidation.every(item => {
        //     return Object.values(item).every(value => value === "" || value === null);            

        // });
        // console.log(serviceLineVal,'serviceLineVal');

        // if (serviceLineVal === true) {
        //     let servicelineValAgain = ClaimsValidator(mainProcedureMacrosServices, mainProcedureMacros, 'Professional')
        //     servicelineValAgain.map((item) => {
        //         if (!isNull(item.DOSFromVal)) {
        //             item.DOSFromVal = ''
        //         }
        //         if (!isNull(item.DOSToVal)) {
        //             item.DOSFromVal = ''
        //         }
        //         if (!isNull(item.POSVal)) {
        //             item.POSVal = ''
        //         }
        //     })
        //     setServiceLineValidation(servicelineValAgain)
        //     console.log(serviceLineVal,'serviceLineVal');

        //     serviceLineVal = servicelineValAgain.every(item => {
        //         return Object.values(item).every(value => value === "" || value === null);
        //     });
        // }
        await ProviderValidation()
        let validation = FormValidator([validate_model], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
        } else if (mainProcedureMacrosServices.length > 0 && ProcedureCodeValidation === true) {
            NotificationHandler('Procedure code cannot be null', enumUtil.enumtoaster.error)
            setIsLoading(false)
        } else if (ICDValidator === true) {        // Check Sequence in ICD's
            setIsLoading(false)
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
        } else if (RepeatingValue) {  // Check Repeating Value in ICD's
            setIsLoading(false)
            NotificationHandler('Repeating values found in diagnosis', enumUtil.enumtoaster.error)
        }
        //  else if (serviceLineVal === false) {
        //     setIsLoading(false)
        //     NotificationHandler('Resolve Serviceline Information Error', enumUtil.enumtoaster.error)
        // }
        else {
            let updatedServiceLineData = []
            if (mainProcedureMacrosServices.length > 0) {
                updatedServiceLineData = mainProcedureMacrosServices.map(item => {
                    const updatedItem = { ...item };
                    for (const key in updatedItem) {
                        if (updatedItem[key] != null) {
                            updatedItem[key] = updatedItem[key] + "";
                        }
                    }
                    return updatedItem;
                });
            }
            let saveModal = {
                "ProcedureMacro": {
                    TableName: enumUtil.enumAPITableName.ProcedureMacro,
                    ID: ProcedureCodes,
                    data: { ...ProcedureMacrosSaveupdatemodel },

                },
                "ProcedureMacroServiceLine": [...updatedServiceLineData]

            }
            setIsLoading(true)
            ServerRequestProtected(API_URL_General + "/SaveProcedureMacro", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        setProcedureCodes(response.id)
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setOnProcedureSave(true)
                        onDeleteProcedure()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const Addnewhandle = () => {
        let error = false
        setIs(true)
        let modal = { ...ProcedureMacrosServices_model }
        let newList = [...mainProcedureMacrosServices]
        let index = mainProcedureMacrosServices.length - 1
        if (mainProcedureMacrosServices.length > 0) {
            if (isNull(mainProcedureMacrosServices[index]['ProcedureCode'])) {
                error = true
                NotificationHandler('Fill Procedure Code ', enumUtil.enumtoaster.warning)
                return

            }
            else if (!isNull(mainProcedureMacrosServices[index]['ID'])) {
                if (!isNull(mainProcedureMacrosServices[index]['Pointer4'])) {
                    if (isNull(mainProcedureMacrosServices[index]['Pointer1']) || isNull(mainProcedureMacrosServices[index]['Pointer2']) || isNull(mainProcedureMacrosServices[index]['Pointer3'])) {
                        error = true
                        NotificationHandler('Pointer values must be in sequence ', enumUtil.enumtoaster.warning)
                        return
                    }
                }
                if (!isNull(mainProcedureMacrosServices[index]['Pointer3'])) {
                    if (isNull(mainProcedureMacrosServices[index]['Pointer1']) || isNull(mainProcedureMacrosServices[index]['Pointer2'])) {
                        error = true
                        NotificationHandler('Pointer values must be in sequence ', enumUtil.enumtoaster.warning)
                        return
                    }
                }
                if (!isNull(mainProcedureMacrosServices[index]['Pointer2'])) {
                    if (isNull(mainProcedureMacrosServices[index]['Pointer1'])) {
                        error = true
                        NotificationHandler('Pointer values must be in sequence ', enumUtil.enumtoaster.warning)
                        return
                    }
                }
                // Modifiers Sequence
                if (!isNull(mainProcedureMacrosServices[index]['ModifierCode4'])) {
                    if (isNull(mainProcedureMacrosServices[index]['ModifierCode1']) || isNull(mainProcedureMacrosServices[index]['ModifierCode2']) || isNull(mainProcedureMacrosServices[index]['ModifierCode3'])) {
                        error = true
                        NotificationHandler('Modifier values must be in sequence ', enumUtil.enumtoaster.warning)
                        return
                    }
                }
                if (!isNull(mainProcedureMacrosServices[index]['ModifierCode3'])) {
                    if (isNull(mainProcedureMacrosServices[index]['ModifierCode1']) || isNull(mainProcedureMacrosServices[index]['ModifierCode2'])) {
                        error = true
                        NotificationHandler('Modifier values must be in sequence ', enumUtil.enumtoaster.warning)
                        return
                    }
                }
                if (!isNull(mainProcedureMacrosServices[index]['ModifierCode2'])) {
                    if (isNull(mainProcedureMacrosServices[index]['ModifierCode1'])) {
                        error = true
                        NotificationHandler('Modifier values must be in sequence ', enumUtil.enumtoaster.warning)
                        return
                    }
                }
            }
        }
        if (error === false) {
            let newValidationlist = JSON.parse(JSON.stringify(serviceLineValidation));
            newValidationlist.push(ServiceLineValidation_Modal)
            setServiceLineValidation(newValidationlist)
            if (!isNull(mainProcedureMacros.ICD1Code)) {
                modal.Pointer1 = '1'
            }
            newList.push(modal)
            setMianProcedureMacrosServices(newList)
        }
    }
    const handleServiceLineChange = (e, id, index, type) => {
        setIs(false)
        let { name, value } = e.target;
        if (type === 'ProcedureCode') {
            setcptBody({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": value })
        } else if (type === 'Modifier') {
            setmodifierBody({ "TableName": enumUtil.enumAPITableName.Modifier, "SearchParam": value })
        }
        let serviceLineItem = [...mainProcedureMacrosServices];
        serviceLineItem[index][name] = value
        setMianProcedureMacrosServices(serviceLineItem)
    }
    const handleSuperSearchList = (data, index, name) => {
        setIs(true)
        let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));
        let serviceLineItem = [...mainProcedureMacrosServices];
        if (!isNull(data)) {
            if (name === 'ProcedureCode') {
                serviceLineItem[index]['ProcedureCodeID'] = data.value + ""
                serviceLineItem[index][name] = data.display
                serviceLineValidationCopy[index]['CPTCodeVal'] = ''
                GetProcedureDetails(data.value, index)
            } else if (name === 'ModifierCode1') {
                serviceLineItem[index]['ModifierCodeID1'] = data.value + ""
                serviceLineItem[index][name] = data.display

            } else if (name === 'ModifierCode2') {
                serviceLineItem[index]['ModifierCodeID2'] = data.value + ""
                serviceLineItem[index][name] = data.display
            } else if (name === 'ModifierCode3') {
                serviceLineItem[index]['ModifierCodeID3'] = data.value + ""
                serviceLineItem[index][name] = data.display
            } else if (name === 'ModifierCode4') {
                serviceLineItem[index]['ModifierCodeID4'] = data.value + ""
                serviceLineItem[index][name] = data.display

            } else if (name === 'POSCode') {
                serviceLineItem[index]['POSCodeID'] = data.value + ""
                serviceLineItem[index][name] = data.display
                serviceLineItem[index]['POSCode'] = data.code + ""
            }
        } else {
            serviceLineItem[index][name] = ''
        }
        setMianProcedureMacrosServices(serviceLineItem)
        setServiceLineValidation(serviceLineValidationCopy)

    }
    const GetProcedureDetails = (value, index) => {
        let serviceLineItem = [...mainProcedureMacrosServices];
        ServerRequestProtected(API_URL + "/GetProcedureDetails", 'post', {
            "TableName": 'Procedure',
            "ID": value + "",
        })
            .then((response) => {
                setIs(true)
                serviceLineItem[index]['Amount'] = response[0].Amount
                setMianProcedureMacrosServices(serviceLineItem)
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
            })
    }
    const handleDeleteRow = (index) => {
        if (mainProcedureMacrosServices[index].ID === '0') {
            const updatedValidation = [...serviceLineValidation.slice(0, index), ...serviceLineValidation.slice(index + 1)]
            const updatedList = [...mainProcedureMacrosServices.slice(0, index), ...mainProcedureMacrosServices.slice(index + 1)];
            setMianProcedureMacrosServices(updatedList);
            setServiceLineValidation(updatedValidation)
        } else {
            const updatedList = [...mainProcedureMacrosServices.slice(0, index), ...mainProcedureMacrosServices.slice(index + 1)];
            const updatedCopyList = [...serviceLineValidation.slice(0, index), ...serviceLineValidation.slice(index + 1)];

            // let data = [...mainProcedureMacrosServices]
            // data.map((item) => {
            //     if (item.ID === mainProcedureMacrosServices[index].ID) {
            //         item.Deleted = '1'
            //     }
            // })
            setMianProcedureMacrosServices(updatedList);
            setServiceLineValidation(updatedCopyList)
            // setProcedureMacroServicesSaveupdatemodel(updatedList)
            // let data = [{...mainProcedureMacros}]
            // data.map((item) => {
            //     if (item.ID === mainProcedureMacros[index].ID) {
            //         item.Deleted = '1'
            //     }
            // })
            // setMianProcedureMacros(data)
        }
    }
    // const handleDeleteRow = (index) => {

    //     if (mainProcedureMacrosServices[index].ID === '0') {
    //         // Case where ID is '0', just remove the row from both arrays
    //         const updatedValidation = [...serviceLineValidation.slice(0, index),...serviceLineValidation.slice(index + 1)];
    //         const updatedList = [...mainProcedureMacrosServices.slice(0, index),...mainProcedureMacrosServices.slice(index + 1)];
    //         setMianProcedureMacrosServices(updatedList);
    //         setServiceLineValidation(updatedValidation);
    //     } else {
    //         let data = [{...mainProcedureMacros}];
    //         data = data.map((item) => {
    //             if (item.ID === mainProcedureMacrosServices[index].ID) {
    //                 return { ...item, Deleted: '1' }; 
    //             }
    //             return item;
    //         });
    //         const updatedList = [...mainProcedureMacrosServices.slice(0, index),...mainProcedureMacrosServices.slice(index + 1)];
    //         setMianProcedureMacrosServices(updatedList); 
    //         setMianProcedureMacros(data);
    //     }
    // };

    const handleOnblurModifiers = (value, name, index) => {
        let serviceLineItem = [...mainProcedureMacrosServices];
        let serviceLineValidationCopy = [...serviceLineValidation];
        if (name === 'ModifierCode1' || name === 'ModifierCode2' || name === 'ModifierCode3' || name === 'ModifierCode4') {
            let modifier1 = serviceLineItem[index]['ModifierCode1'] + ""
            let modifier2 = serviceLineItem[index]['ModifierCode2'] + ""
            let modifier3 = serviceLineItem[index]['ModifierCode3'] + ""
            let modifier4 = serviceLineItem[index]['ModifierCode4'] + ""
            let modifier = [modifier1, modifier2, modifier3, modifier4]
            const uniqueSet = new Set();
            let hasDuplicates = false;

            for (const item of modifier) {
                if (!isNull(item)) {
                    if (uniqueSet.has(item)) {
                        hasDuplicates = true;
                        break;
                    }
                    uniqueSet.add(item);
                }
            }

            if (hasDuplicates) {
                serviceLineValidationCopy[index]['ModifierCode1UNI'] = 'Modifiers must be unique'
            } else {
                serviceLineValidationCopy[index]['ModifierCode1UNI'] = ''
            }
            let foundNull = false;
            let Error = false;
            for (let i = 0; i < 4; i++) {
                if (isNull(modifier[i])) {
                    foundNull = true
                }
                if (!isNull(modifier[i]) && foundNull === true) {
                    Error = true
                }
            }
            if (Error) {
                serviceLineValidationCopy[index]['ModifierCode1Val'] = 'Modifiers must be in sequence'
            } else {
                serviceLineValidationCopy[index]['ModifierCode1Val'] = ''
            }
            setServiceLineValidation([...serviceLineValidationCopy])
        }
    }
    const handleOnblurServiceline = (e, index) => {
        const { value, name } = (e.target)
        let serviceLineItem = [...mainProcedureMacrosServices];
        let serviceLineValidationCopy = JSON.parse(JSON.stringify(serviceLineValidation));
        if (name === 'Pointer1' || name === 'Pointer2' || name === 'Pointer3' || name === 'Pointer4') {
            let pointer1 = serviceLineItem[index]['Pointer1'] + ""
            let pointer2 = serviceLineItem[index]['Pointer2'] + ""
            let pointer3 = serviceLineItem[index]['Pointer3'] + ""
            let pointer4 = serviceLineItem[index]['Pointer4'] + ""
            let pointer = [pointer1, pointer2, pointer3, pointer4]
            let intValue = parseInt(value)
            let icdIndex = 'ICD' + value + 'Code'

            if (intValue < 1 || intValue > 12 && !isNaN(intValue)) {
                serviceLineValidationCopy[index][name + 'ICD'] = 'pointer value cannot be less than 1 and greater than 12'
            } else if (isNull(mainProcedureMacros[icdIndex]) && icdIndex !== 'ICDCode') {
                if (!isNull(icdIndex)) {
                    if (isNull(value)) {
                        serviceLineValidationCopy[index][name + 'ICD'] = ''
                    } else {
                        serviceLineValidationCopy[index]['Pointer1UNI'] = ''
                        serviceLineValidationCopy[index][name + 'ICD'] = 'Cannot add pointer against empty ICD'
                    }
                }
            } else {
                serviceLineValidationCopy[index][name + 'ICD'] = ''
                const uniqueSet = new Set();
                let hasDuplicates = false;

                for (const item of pointer) {
                    if (!isNull(item)) {
                        if (uniqueSet.has(item)) {
                            hasDuplicates = true;
                            break;
                        }
                        uniqueSet.add(item);
                    }
                }
                if (hasDuplicates) {
                    serviceLineValidationCopy[index]['Pointer1UNI'] = 'Pointers must be unique'
                } else {
                    serviceLineValidationCopy[index]['Pointer1UNI'] = ''
                }
            }
            let foundNull = false;
            let Error = false;
            for (let i = 0; i < 4; i++) {
                if (isNull(pointer[i])) {
                    foundNull = true
                }
                if (!isNull(pointer[i]) && foundNull === true) {
                    Error = true
                }
            }
            if (Error) {
                serviceLineValidationCopy[index]['Pointer1Val'] = 'Pointers must be in sequence'
            } else {
                serviceLineValidationCopy[index]['Pointer1Val'] = ''
            }
            setServiceLineValidation(serviceLineValidationCopy)
        }

    }
    useEffect(() => {
        if (!isNull(ProcedureCodes) && ProcedureCodes !== '0') {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": ProcedureCodes + "",
                "TableName": enumUtil.enumAPITableName.ProcedureMacro
            }).then((response) => {
                setIsLoading(false)
                setIs(true)
                setMianProcedureMacros(response[0])
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
        if (!isNull(ProcedureCodes) && ProcedureCodes !== '0') {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": ProcedureCodes,
                "TableName": enumUtil.enumAPITableName.ProcedureMacroServiceLine
            }).then((response) => {
                setIsLoading(false)
                setIs(true)
                setMianProcedureMacrosServices(response)
                let servicelineEmptyRows = [] // for validation purpose
                response.map((item) => {
                    servicelineEmptyRows.push(ServiceLineValidation_Modal)
                })
                setServiceLineValidation(servicelineEmptyRows)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }


    }, [ProcedureCodes])
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }

    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    const AddDiagnosis = () => {
        setisOpenDiagnosis(true)
        // setDiagnosisCode(ID)
    }
    const CloseDiagnosis = () => {
        setisOpenDiagnosis(false)
        console.log("Test")
    }
    const DeleteDiagnosis = () => {
        setisOpenDiagnosis(false)
        setIsClose((Math.random()));
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.ProcedureMacro} ID={ProcedureCodes} onClose={onDeleteProcedure} />
    }
    let PopupScreen = "";
    if (isOpenDiagnosis) {
        PopupScreen = <AddNewDiagnosis isOpenDiagnosis={isOpenDiagnosis} onClose={CloseDiagnosis} onDeleteDiagnosis={DeleteDiagnosis} DiagnosisCode={DiagnosisCode} type={type} />
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={ProcedureCodes + ""} TableName={enumUtil.enumAPITableName.Procedure} />
    }
    const SetProcedurMacroName = () => {
        if (mainProcedureMacros.Name != null && mainProcedureMacros.Name != "") {
            return (
                <p className="heading sm">{mainProcedureMacros.Name}</p>
            )
        } else {
            return (
                <p className="heading sm">Add New Procedure Code</p>
            )
        }
    }
    let areAllValuesNullOrEmpty = (obj) => {
        for (let key in obj) {
            if (obj[key] !== null && obj[key] !== "") {
                return false;
            }
        }
        return true;
    }
    // diagnosis popup
    const [isOpenNewDiagnosis, setisOpenNewDiagnosis] = useState(false)
    const [icdCode, setIcdCode] = useState()
    const [ActiveICDName, setActiveICDName] = useState('')
    const handleAddNewICD = (searchValue, name) => {
        setActiveICDName(name)
        setIcdCode(searchValue)
        setisOpenNewDiagnosis(true)
    }
    const handleCloseICD = () => {
        setisOpenNewDiagnosis(false)
    }
    const handleOnSaveICD = (selectedData) => {
        if (!isNull(ActiveICDName)) {
            handleSelectDiagnosisData(selectedData, ActiveICDName, 'server')
        }
        handleCloseICD()
    }
    let NewICDPopup = ''
    if (isOpenNewDiagnosis) {
        NewICDPopup = <AddNewDiagnosis isOpenDiagnosis={isOpenNewDiagnosis} onClose={handleCloseICD} Diagnosisvalue={icdCode} onDeleteProcedure={handleCloseICD} onDeleteDiagnosis={handleCloseICD} IsOpen={true} onICDSave={handleOnSaveICD} />
    }

    // service line popup
    const [isOpenProcedureCode, setisOpenProcedure] = useState(false)
    const [ActiveCode, setActiveCode] = useState('')
    const [ActiveCodeindex, setActiveCodeindex] = useState('')

    const handleAddNewCPT = (searchValue, name, index) => {
        if (!isNull(searchValue)) {
            setActiveCode(searchValue)
            setActiveCodeindex(index)
        } else {
            setActiveCode('')
        }
        setisOpenProcedure(true)
    }
    const handleCloseCPT = () => {
        setisOpenProcedure(false)
    }
    const handleOnSaveCPT = (selectedData) => {
        // if (!isNull(ActiveCodeindex)) {
        handleSuperSearchList(selectedData, ActiveCodeindex, 'ProcedureCode', false, 'CPT')
        handleClearState()
        handleCloseCPT()
        // }
    }
    let ProcedurePopup = ''
    if (isOpenProcedureCode) {
        ProcedurePopup = <AddNewProcedureCodes isOpenProcedure={isOpenProcedureCode} onClose={handleCloseCPT} ProcedureCode={ActiveCode} onDeleteProcedure={handleCloseCPT} handleOnSaveICD={handleOnSaveCPT} isOpenFromList={true} />
    }
    // modifier popup
    const [isOpenModifierNew, setisOpenModifierNew] = useState(false)
    const [ActiveCodeName, setActiveCodeName] = useState('')
    const handleAddNewModifier = (searchvalue, name, index) => {
        if (!isNull(searchvalue) && !isNull(name)) {
            setActiveCode(searchvalue)
            setActiveCodeName(name)
            setActiveCodeindex(index)
        } else {
            setActiveCode('')
        }
        setisOpenModifierNew(true)

    }
    const handleCloseModifier = () => {
        setisOpenModifierNew(false)
    }
    const handleSelectModofier = (selectedData) => {
        handleSuperSearchList(selectedData, ActiveCodeindex, ActiveCodeName, '', 'CPT')
        handleClearState()
        handleCloseModifier()
    }

    const handleClearState = () => {
        setActiveCode('')
        setActiveCodeindex()
        setActiveCodeName('')
    }
    let ModifierPopup = ''
    if (isOpenModifierNew) {
        ModifierPopup = <AddNewModifier isOpenModifier={isOpenModifierNew} onClose={handleCloseModifier} ModifierCode={ActiveCode} onDeleteModifier={handleCloseModifier} isOpenFromList={true} handleSelectModofier={handleSelectModofier} />
    }


    const AddNewProcedureMacroModalBody = () => {
        return (
            <div className="d-flex m-0 row">
                <div className="col-md-3 br-right-1 br-clr ps-0">
                    <div className="form-group input">
                        <label htmlFor="ProcedureMacroName">Name<span className='req'>*</span></label>
                        <div className={providerValidationModal.valName ? 'form-group input error' : 'form-group input'}>
                            <input type="text" className="form-control"
                                id="Name"
                                name="Name"
                                autoComplete="off"
                                value={mainProcedureMacros.Name}
                                onChange={handleProcedureMacrosChange}
                            />
                            {providerValidationModal.valName}
                        </div>
                    </div>
                    <div className="form-group input">
                        <label htmlFor="procedureMacroType">Type</label>
                        <input type="text" className="form-control"
                            id="Type"
                            name="Type"
                            autoComplete="off"
                            value={mainProcedureMacros.Type}
                            onChange={handleProcedureMacrosChange} />
                    </div>
                    <div className="form-group input">
                        <label htmlFor="description">Description</label>
                        <textarea className="form-control"
                            id="Description"
                            name="Description"
                            value={mainProcedureMacros.Description}
                            onChange={handleProcedureMacrosChange}
                            rows="3"></textarea>
                    </div>
                    <div className="d-flex ps-1">
                        <div class="form-check d-flex custom_check_box items-align-center gap-1 ps-3">
                            <input type="checkbox"
                                class="form-check-input p-0 mt-0"
                                id="Active"
                                name="Active"
                                autoComplete="off"
                                checked={mainProcedureMacros.Active}
                                value={mainProcedureMacros.Active}
                                onChange={handleProcedureMacrosChange} />
                        </div>
                        <label class="form-check-label font-m heading" for="Active">Active</label>
                    </div>
                </div>
                <div className="col-md-9  px-0">
                    <div className="hk-header-gray">
                        <span className="heading">Diagnosis/ICD(s)</span>
                        <p style={{ color: 'red' }} className='text fst-italic'>
                            {ICDvalidationModal.icd1ValField}
                            {ICDvalidationModal.icd2ValField}
                            {ICDvalidationModal.icd3ValField}
                            {ICDvalidationModal.icd4ValField}
                            {ICDvalidationModal.icd5ValField}
                            {ICDvalidationModal.icd6ValField}
                            {ICDvalidationModal.icd7ValField}
                            {ICDvalidationModal.icd8ValField}
                            {ICDvalidationModal.icd9ValField}
                            {ICDvalidationModal.icd10ValField}
                            {ICDvalidationModal.icd11ValField}
                            {ICDvalidationModal.icd12ValField}
                        </p>
                        <p style={{ color: 'red' }} className='text fst-italic'> {RepeatingValue} </p>
                    </div>
                    <div className="hk-content-micro">
                        <div className="row position-relative pe-5">

                            <div className="col-md-4 position-relative">
                                <div className='form-group input'>
                                    <div className="align-items-center label-head  d-flex justify-content-between mb-1">
                                        <label htmlFor="">ICD1<span className='req'>*</span></label>
                                        <div>
                                            <button class="btn-icon-circle btn-xs" onClick={AddDiagnosis}><i class="icon-plus-icon"></i></button>
                                        </div>
                                    </div>
                                    <SuperICDandCPTSearch
                                        type='server'
                                        customData={RecentICDs}
                                        id='Dx'
                                        name='ICD1Code'
                                        onChange={handleDiagnosisChange}
                                        getSelectedData={handleSelectDiagnosisData}
                                        searchValue={mainProcedureMacros.ICD1Code}
                                        searchBy={['display', 'Description']}
                                        tableData={[
                                            { columName: 'Code', bindingValue: 'display', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                        ]}
                                        ApiLink={API_URL + "/ICDInstantSearch"}
                                        method='post'
                                        postBody={icdBody}
                                        disabled={true}
                                        // placeholder={""}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ICDvalidationModal.icd1ValField}
                                        isItemSelected={!isNull(mainProcedureMacros.ICD1Code) ? true : false}
                                        handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                        showPatDx={false}
                                    />
                                    {/* {providerValidationModal.valCDI} */}

                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className='form-group input'>
                                    <label>ICD2</label>
                                    <SuperICDandCPTSearch
                                        type='server'
                                        customData={RecentICDs}
                                        id='Dx'
                                        name='ICD2Code'
                                        onChange={handleDiagnosisChange}
                                        getSelectedData={handleSelectDiagnosisData}
                                        searchValue={mainProcedureMacros.ICD2Code}
                                        searchBy={['display', 'Description']}
                                        tableData={[
                                            { columName: 'Code', bindingValue: 'display', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                        ]}
                                        ApiLink={API_URL + "/ICDInstantSearch"}
                                        method='post'
                                        postBody={icdBody}
                                        disabled={true}
                                        // placeholder={""}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ICDvalidationModal.icd1ValField}
                                        isItemSelected={!isNull(mainProcedureMacros.ICD2Code) ? true : false}
                                        handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                        showPatDx={false}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className='form-group input'>
                                    <label>ICD3</label>
                                    <SuperICDandCPTSearch
                                        type='server'
                                        customData={RecentICDs}
                                        id='Dx'
                                        name='ICD3Code'
                                        onChange={handleDiagnosisChange}
                                        getSelectedData={handleSelectDiagnosisData}
                                        searchValue={mainProcedureMacros.ICD3Code}
                                        searchBy={['display', 'Description']}
                                        tableData={[
                                            { columName: 'Code', bindingValue: 'display', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                        ]}
                                        ApiLink={API_URL + "/ICDInstantSearch"}
                                        method='post'
                                        postBody={icdBody}
                                        disabled={true}
                                        // placeholder={""}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ICDvalidationModal.icd1ValField}
                                        isItemSelected={!isNull(mainProcedureMacros.ICD3Code) ? true : false}
                                        handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                        showPatDx={false}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row position-relative pe-5 mt-2">
                            <div className="col-md-4">
                                <div className='form-group input'>
                                    <label>ICD4</label>
                                    <SuperICDandCPTSearch
                                        type='server'
                                        customData={RecentICDs}
                                        id='Dx'
                                        name='ICD4Code'
                                        onChange={handleDiagnosisChange}
                                        getSelectedData={handleSelectDiagnosisData}
                                        searchValue={mainProcedureMacros.ICD4Code}
                                        searchBy={['display', 'Description']}
                                        tableData={[
                                            { columName: 'Code', bindingValue: 'display', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                        ]}
                                        ApiLink={API_URL + "/ICDInstantSearch"}
                                        method='post'
                                        postBody={icdBody}
                                        disabled={true}
                                        // placeholder={""}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ICDvalidationModal.icd1ValField}
                                        isItemSelected={!isNull(mainProcedureMacros.ICD4Code) ? true : false}
                                        handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                        showPatDx={false}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className='form-group input'>
                                    <label>ICD5</label>
                                    <SuperICDandCPTSearch
                                        type='server'
                                        customData={RecentICDs}
                                        id='Dx'
                                        name='ICD5Code'
                                        onChange={handleDiagnosisChange}
                                        getSelectedData={handleSelectDiagnosisData}
                                        searchValue={mainProcedureMacros.ICD5Code}
                                        searchBy={['display', 'Description']}
                                        tableData={[
                                            { columName: 'Code', bindingValue: 'display', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                        ]}
                                        ApiLink={API_URL + "/ICDInstantSearch"}
                                        method='post'
                                        postBody={icdBody}
                                        disabled={true}
                                        // placeholder={""}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ICDvalidationModal.icd1ValField}
                                        isItemSelected={!isNull(mainProcedureMacros.ICD5Code) ? true : false}
                                        handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                        showPatDx={false}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className='form-group input'>
                                    <label>ICD6</label>
                                    <SuperICDandCPTSearch
                                        type='server'
                                        customData={RecentICDs}
                                        id='Dx'
                                        name='ICD6Code'
                                        onChange={handleDiagnosisChange}
                                        getSelectedData={handleSelectDiagnosisData}
                                        searchValue={mainProcedureMacros.ICD6Code}
                                        searchBy={['display', 'Description']}
                                        tableData={[
                                            { columName: 'Code', bindingValue: 'display', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                        ]}
                                        ApiLink={API_URL + "/ICDInstantSearch"}
                                        method='post'
                                        postBody={icdBody}
                                        disabled={true}
                                        // placeholder={""}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ICDvalidationModal.icd1ValField}
                                        isItemSelected={!isNull(mainProcedureMacros.ICD6Code) ? true : false}
                                        handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                        showPatDx={false}
                                    />
                                </div>
                            </div>
                            <div className="hk-diagWrap__Btn">
                                <button className='btn-icon-circle btn-xs' onClick={() => setLoadICD(!loadICD)}><i className="icon-Group-5719"></i></button>
                            </div>
                        </div>
                        {loadICD && <>
                            <div className='row pe-5'>
                                <div className="col-md-4">
                                    <div className='form-group input'>
                                        <label>ICD7</label>
                                        <SuperICDandCPTSearch
                                            type='server'
                                            customData={RecentICDs}
                                            id='Dx'
                                            name='ICD7Code'
                                            onChange={handleDiagnosisChange}
                                            getSelectedData={handleSelectDiagnosisData}
                                            searchValue={mainProcedureMacros.ICD7Code}
                                            searchBy={['display', 'Description']}
                                            tableData={[
                                                { columName: 'Code', bindingValue: 'display', },
                                                { columName: 'Description', bindingValue: 'Description', },
                                            ]}
                                            ApiLink={API_URL + "/ICDInstantSearch"}
                                            method='post'
                                            postBody={icdBody}
                                            disabled={true}
                                            // placeholder={""}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            inputError={ICDvalidationModal.icd1ValField}
                                            isItemSelected={!isNull(mainProcedureMacros.ICD7Code) ? true : false}
                                            handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                            showPatDx={false}
                                        />
                                        {/* {ICDvalidationModal.icd7ValField} */}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className='form-group input'>
                                        <label>ICD8</label>
                                        <SuperICDandCPTSearch
                                            type='server'
                                            customData={RecentICDs}
                                            id='Dx'
                                            name='ICD8Code'
                                            onChange={handleDiagnosisChange}
                                            getSelectedData={handleSelectDiagnosisData}
                                            searchValue={mainProcedureMacros.ICD8Code}
                                            searchBy={['display', 'Description']}
                                            tableData={[
                                                { columName: 'Code', bindingValue: 'display', },
                                                { columName: 'Description', bindingValue: 'Description', },
                                            ]}
                                            ApiLink={API_URL + "/ICDInstantSearch"}
                                            method='post'
                                            postBody={icdBody}
                                            disabled={true}
                                            // placeholder={""}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            inputError={ICDvalidationModal.icd1ValField}
                                            isItemSelected={!isNull(mainProcedureMacros.ICD8Code) ? true : false}
                                            handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                            showPatDx={false}
                                        />
                                        {/* {ICDvalidationModal.icd8ValField} */}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className='form-group input'>
                                        <label>ICD9</label>
                                        <SuperICDandCPTSearch
                                            type='server'
                                            customData={RecentICDs}
                                            id='Dx'
                                            name='ICD9Code'
                                            onChange={handleDiagnosisChange}
                                            getSelectedData={handleSelectDiagnosisData}
                                            searchValue={mainProcedureMacros.ICD9Code}
                                            searchBy={['display', 'Description']}
                                            tableData={[
                                                { columName: 'Code', bindingValue: 'display', },
                                                { columName: 'Description', bindingValue: 'Description', },
                                            ]}
                                            ApiLink={API_URL + "/ICDInstantSearch"}
                                            method='post'
                                            postBody={icdBody}
                                            disabled={true}
                                            // placeholder={""}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            inputError={ICDvalidationModal.icd1ValField}
                                            isItemSelected={!isNull(mainProcedureMacros.ICD9Code) ? true : false}
                                            handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                            showPatDx={false}
                                        />
                                        {/* {ICDvalidationModal.icd9ValField} */}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className='form-group input'>
                                        <label>ICD10</label>
                                        <SuperICDandCPTSearch
                                            type='server'
                                            customData={RecentICDs}
                                            id='Dx'
                                            name='ICD10Code'
                                            onChange={handleDiagnosisChange}
                                            getSelectedData={handleSelectDiagnosisData}
                                            searchValue={mainProcedureMacros.ICD10Code}
                                            searchBy={['display', 'Description']}
                                            tableData={[
                                                { columName: 'Code', bindingValue: 'display', },
                                                { columName: 'Description', bindingValue: 'Description', },
                                            ]}
                                            ApiLink={API_URL + "/ICDInstantSearch"}
                                            method='post'
                                            postBody={icdBody}
                                            disabled={true}
                                            // placeholder={""}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            inputError={ICDvalidationModal.icd1ValField}
                                            isItemSelected={!isNull(mainProcedureMacros.ICD10Code) ? true : false}
                                            handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                            showPatDx={false}
                                        />
                                        {/* {ICDvalidationModal.icd10ValField} */}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className='form-group input'>
                                        <label>ICD11</label>
                                        <SuperICDandCPTSearch
                                            type='server'
                                            customData={RecentICDs}
                                            id='Dx'
                                            name='ICD11Code'
                                            onChange={handleDiagnosisChange}
                                            getSelectedData={handleSelectDiagnosisData}
                                            searchValue={mainProcedureMacros.ICD11Code}
                                            searchBy={['display', 'Description']}
                                            tableData={[
                                                { columName: 'Code', bindingValue: 'display', },
                                                { columName: 'Description', bindingValue: 'Description', },
                                            ]}
                                            ApiLink={API_URL + "/ICDInstantSearch"}
                                            method='post'
                                            postBody={icdBody}
                                            disabled={true}
                                            // placeholder={""}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            inputError={ICDvalidationModal.icd1ValField}
                                            isItemSelected={!isNull(mainProcedureMacros.ICD11Code) ? true : false}
                                            handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                            showPatDx={false}
                                        />
                                        {/* {ICDvalidationModal.icd11ValField} */}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className='form-group input'>
                                        <label>ICD12</label>
                                        <SuperICDandCPTSearch
                                            type='server'
                                            customData={RecentICDs}
                                            id='Dx'
                                            name='ICD12Code'
                                            onChange={handleDiagnosisChange}
                                            getSelectedData={handleSelectDiagnosisData}
                                            searchValue={mainProcedureMacros.ICD12Code}
                                            searchBy={['display', 'Description']}
                                            tableData={[
                                                { columName: 'Code', bindingValue: 'display', },
                                                { columName: 'Description', bindingValue: 'Description', },
                                            ]}
                                            ApiLink={API_URL + "/ICDInstantSearch"}
                                            method='post'
                                            postBody={icdBody}
                                            disabled={true}
                                            // placeholder={""}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            inputError={ICDvalidationModal.icd1ValField}
                                            isItemSelected={!isNull(mainProcedureMacros.ICD12Code) ? true : false}
                                            handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                            showPatDx={false}
                                        />
                                        {/* {ICDvalidationModal.icd12ValField} */}
                                    </div>
                                </div>
                            </div>
                        </>}
                    </div>
                    <div className="hk-header-gray blue">
                        <span className="heading">Service Lines</span>
                        <button className="btn btn-orange btn-05x no-width" onClick={Addnewhandle}>Add new  </button>
                    </div>
                    <div className="hk-content-micro p-0">
                        <div className="card-body p-0 hk-expand-table ad-expand-table hk-micro-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <div className="head-flex">
                                                <span>Procedure Code</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="head-flex">
                                                <span>Modifiers</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="head-flex">
                                                <span>Pointers</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="head-flex">
                                                <span>Units</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="head-flex">
                                                <span>Amount Per Unit</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="head-flex">
                                                <span>More info</span>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {mainProcedureMacrosServices.length > 0 ?
                                        <>
                                            {mainProcedureMacrosServices.map((data, index) => {
                                                let CheckValidation = areAllValuesNullOrEmpty(serviceLineValidation[index])

                                                return (
                                                    <>
                                                        {data.Deleted && data.Deleted === '1' ? null : (
                                                            <>
                                                                <tr key={index}>
                                                                    <td className="bg-field-show">
                                                                        <div className='hk-table-flex bg-trans-nill'>
                                                                            {/* <SuperSearchList
                                                                                width={'100px'}
                                                                                type='server'
                                                                                id='ProcedureCode'
                                                                                name='ProcedureCode'
                                                                                searchValue={data.ProcedureCode}
                                                                                ApiLink={API_URL + "/CPTInstantSearch"}
                                                                                method='post'
                                                                                postBody={cptBody}
                                                                                // onChange = {(e) => handleChangeInstantSearch(e, 'ProcedureCode', data.RowID)}
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'ProcedureCode')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ProcedureCode')}
                                                                                is={is}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                disabled={true}
                                                                                placeholder={"Search..."}
                                                                            /> */}

                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentCPTs}
                                                                                id='ProcedureCode'
                                                                                name='ProcedureCode'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'ProcedureCode')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ProcedureCode', false, 'CPT')}
                                                                                searchValue={data.ProcedureCode}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/CPTInstantSearch"}
                                                                                method='post'
                                                                                postBody={cptBody}
                                                                                disabled={true}
                                                                                // placeholder={""}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                inputError={!isNull(serviceLineValidation[index]?.CPTCodeVal) ? true : false}
                                                                                isItemSelected={!isNull(data.ProcedureCode) ? true : false}
                                                                                handleAddNewCode={(searchValue, name) => handleAddNewCPT(searchValue, name, index)}
                                                                            // handleonFocus={handleOnFocusServiceline}
                                                                            // handleOnblur={handleOnBlurForHover}
                                                                            />

                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className='hk-table-flex'>
                                                                            {/* <SuperSearchList
                                                                                width={"38px"}
                                                                                type='server'
                                                                                id='ModifierCode1'
                                                                                name='ModifierCode1'
                                                                                searchValue={data.ModifierCode1}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                // onChange={(e) => handleChangeInstantSearch(e, 'Modifier', data.RowID)}
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode1')}
                                                                                is={is}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                disabled={true}
                                                                                placeholder={false}
                                                                                handleOnblur={(value, name) => handleOnblurModifiers(value, name, index)}
                                                                            /> */}
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode1'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode1', '', 'CPT')}
                                                                                searchValue={data.ModifierCode1}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                // placeholder={""}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                                                                isItemSelected={!isNull(data.ModifierCode1) ? true : false}
                                                                                handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                                placeholder={false}
                                                                                // handleonFocus={handleOnFocusServiceline}
                                                                                handleOnblur={(value, name) => handleOnblurModifiers(value, name, index)}
                                                                            />
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode2'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode2', '', 'CPT')}
                                                                                searchValue={data.ModifierCode2}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                // placeholder={""}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                                                                isItemSelected={!isNull(data.ModifierCode2) ? true : false}
                                                                                handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                                placeholder={false}
                                                                                // handleonFocus={handleOnFocusServiceline}
                                                                                handleOnblur={(value, name) => handleOnblurModifiers(value, name, index)}
                                                                            />
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode3'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode3', '', 'CPT')}
                                                                                searchValue={data.ModifierCode3}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                // placeholder={""}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                                                                isItemSelected={!isNull(data.ModifierCode3) ? true : false}
                                                                                handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                                placeholder={false}
                                                                                // handleonFocus={handleOnFocusServiceline}
                                                                                handleOnblur={(value, name) => handleOnblurModifiers(value, name, index)}
                                                                            />
                                                                            <SuperICDandCPTSearch
                                                                                type='server'
                                                                                customData={RecentModifiers}
                                                                                id='Modifier Code'
                                                                                name='ModifierCode4'
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                                                                getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode4', '', 'CPT')}
                                                                                searchValue={data.ModifierCode4}
                                                                                searchBy={['display', 'Description']}
                                                                                tableData={[
                                                                                    { columName: 'Code', bindingValue: 'display', },
                                                                                    { columName: 'Description', bindingValue: 'Description', },
                                                                                ]}
                                                                                ApiLink={API_URL + "/ModifierInstantSearch"}
                                                                                method='post'
                                                                                postBody={modifierBody}
                                                                                disabled={true}
                                                                                // placeholder={""}
                                                                                sup_btn='sup_btn-Inp'
                                                                                sup_inp='superSearchVisitInp'
                                                                                inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                                                                isItemSelected={!isNull(data.ModifierCode4) ? true : false}
                                                                                handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                                                                placeholder={false}
                                                                                // handleonFocus={handleOnFocusServiceline}
                                                                                handleOnblur={(value, name) => handleOnblurModifiers(value, name, index)}
                                                                            />
                                                                            <i class="icon-search"></i>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className='hk-table-flex'>
                                                                            <input
                                                                                variant="outlined"
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="Pointer1"
                                                                                id="Pointer1"
                                                                                autoComplete="off"
                                                                                maxLength={2}
                                                                                value={data.Pointer1}
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer1')}
                                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            />
                                                                            <input
                                                                                variant="outlined"
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="Pointer2"
                                                                                id="Pointer2"
                                                                                maxLength={2}
                                                                                value={data.Pointer2}
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer2')}
                                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            />
                                                                            <input
                                                                                variant="outlined"
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="Pointer3"
                                                                                id="Pointer3"
                                                                                autoComplete="off"
                                                                                maxLength={2}
                                                                                value={data.Pointer3}
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer3')}
                                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            />
                                                                            <input
                                                                                variant="outlined"
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="Pointer4"
                                                                                id="Pointer4"
                                                                                autoComplete="off"
                                                                                maxLength={2}
                                                                                value={data.Pointer4}
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer4')}
                                                                                onBlur={(e) => handleOnblurServiceline(e, index)}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td >
                                                                        <div className='hk-table-flex'>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control units"
                                                                                name="Units"
                                                                                id="Units"
                                                                                autoComplete="off"
                                                                                variant="outlined"
                                                                                value={data.Units}
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Units')}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className='hk-table-flex'>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control units"
                                                                                name="Amount"
                                                                                id="Amount"
                                                                                autoComplete="off"
                                                                                variant="outlined"
                                                                                value={data.Amount}
                                                                                onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Amount')}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <button className="btn-icon-transparent" onClick={() => handleDeleteRow(index)}>
                                                                            <i class="bi bi-trash-fill" style={{ color: 'red' }}></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    {CheckValidation === true ? null :
                                                                        <td colSpan={12} className='message error_message'>
                                                                            {!isNull(serviceLineValidation[index].CPTCodeVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index].CPTCodeVal} </p> : null}
                                                                            {!isNull(serviceLineValidation[index].ModifierCode1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index].ModifierCode1Val} </p> : null}
                                                                            {!isNull(serviceLineValidation[index].ModifierCode1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index].ModifierCode1UNI} </p> : null}
                                                                            {!isNull(serviceLineValidation[index].Pointer1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index].Pointer1Val} </p> : null}
                                                                            {!isNull(serviceLineValidation[index].Pointer1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index].Pointer1UNI} </p> : null}
                                                                            {!isNull(serviceLineValidation[index].Pointer1ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index].Pointer1ICD} </p> : null}
                                                                            {!isNull(serviceLineValidation[index].Pointer2ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index].Pointer2ICD} </p> : null}
                                                                            {!isNull(serviceLineValidation[index].Pointer3ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index].Pointer3ICD} </p> : null}
                                                                            {!isNull(serviceLineValidation[index].Pointer4ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index].Pointer4ICD} </p> : null}
                                                                            {!isNull(serviceLineValidation[index].UnitsVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index].UnitsVal} </p> : null}
                                                                        </td>
                                                                    }
                                                                </tr>
                                                            </>
                                                        )
                                                        }
                                                    </>
                                                )
                                            })}

                                        </> : null
                                    }
                                </tbody>
                            </table>
                            {/* {isOpenChild === true ? <ServiceLineChild /> : null} */}
                        </div>
                    </div>
                </div>
            </div>)
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {popup}
            {type && type === "Wizard" ?
                <>
                    {AuditPopup}
                    {isLoading ? <Loader /> : null}
                    {NewICDPopup}
                    {ProcedurePopup}
                    {ModifierPopup}
                    {AddNewProcedureMacroModalBody()}
                    <ModalFooter isSaved={onProcedureSave ? onDeleteProcedure : onClose} handleSave={handleSaveProvider} onClose={onClose} UpdatedDate={mainProcedureMacros.UpdatedDate} UpdatedBy={mainProcedureMacros.UpdatedBy} ID={ProcedureCodes} IsEditAllowed={IsEditAllowed} />
                </>
                :
                <Modal show={isOpenProcedure} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-xxl hk-modal-v1 justify-content-center add_new_procedre hk-pm-modal">
                    {AuditPopup}
                    {PopupScreen}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetProcedurMacroName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} isClosed={onProcedureSave ? onDeleteProcedure : onClose} DeletePopup={DeletePopup} key={633} Name={"Procedure Macro"} IsDeleteAllowed={IsDeleteAllowed} />
                        {isLoading ? <Loader /> : null}
                        {NewICDPopup}
                        {AddNewProcedureMacroModalBody()}
                    </Modal.Body>
                    <ModalFooter isSaved={onProcedureSave ? onDeleteProcedure : onClose} handleSave={handleSaveProvider} onClose={onClose} UpdatedDate={mainProcedureMacros.UpdatedDate} UpdatedBy={mainProcedureMacros.UpdatedBy} ID={ProcedureCodes} IsEditAllowed={IsEditAllowed} />
                </Modal>
            }

        </React.Fragment>
    );
};

export default ProcedureMacros;




